import axios from "axios"
import Qs from "qs"
import { compose } from "ramda"
import $tm_message_box from "@/components/common/MessageBox.js"
import { ElLoading } from "element-plus"
import router from "@/router"
import store from "@/store"

let loadingInstance = null
console.log("process.env", process.env)
console.log(process.env.NODE_ENV, ":", process.env.VUE_APP_SERVER_ROOT)
const service = axios.create({
  baseURL: '/payment',
  timeout: 60000,
  withCredentials: true,
})

service.interceptors.request.use(
  config => {
    // config.headers['Authorization'] = t;
    const conf = config
    return conf
  },
  error => {
    $tm_message_box.toast(error.message || error.msg || "异常", {
      type: "error",
    })
    return Promise.reject(new Error({ code: -1, message: error }))
  }
)

service.interceptors.response.use(
  response => {
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
    if (response.data.code === 0 || response.data.result == "success") {
      return Promise.resolve(response.data)
    }
 
    if (response.config.responseType === "blob" && response.status == 200) {
      if (response.headers["content-type"] != "application/json") {
        let imageType = response.headers["content-type"]
        const blob = new Blob([response.data], { type: imageType })
        const imageUrl = (window.URL || window.webkitURL).createObjectURL(blob)
        return Promise.resolve(imageUrl)
      } else {
        const utf8decoder = new TextDecoder()
        const u8arr = new Uint8Array(response.data)
        const temp = utf8decoder.decode(u8arr) // 将二进制数据转为字符串
        response.data = JSON.parse(temp)
      }
    }
    if (!response.config.hideToast) {
      $tm_message_box.toast(response.data.message || response.data.msg || "异常", {
        type: "error",
        showClose: false,
      })
    }
    console.log(response.data, 'respons')
    // 未登录
    if (response.data.code == 10000) {
      setTimeout(() => {
        store.dispatch("logout").then(() => {
          router.push({
            name: "Login",
            replace: true,
          })
        })
      }, 1000)
    }

    //     //用户被禁用
    //     if (response.data.code == 30209) {
    //       Router.push({
    //         name: "Login",
    //         replace: true,
    //       });
    //     }

    //     //没有访问权限
    //     if (response.data.code == 30201) {
    //       Router.push({
    //         name: "403",
    //         replace: true,
    //       });
    //     }
    //   }
    return Promise.reject(response.data)
  },
  error => {
    console.log(error)
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
    const {
      status,
      statusText,
      data: { msg },
    } = error.response
    if (status === 424) {
      //
    } else {
      if (!error.config.hideToast) {
        $tm_message_box.toast(msg || `网络开小差了，请稍候重试，服务代码：${statusText}`, {
          type: "error",
        })
      }
    }
    return Promise.reject(error.response)
  }
)

const fetch = (method, url, headers, params, config = {}, body) => {
  const key = (method === "get" && !body) ? "params" : "data"
  const data =
    headers["Content-Type"] === "application/x-www-form-urlencoded" ? Qs.stringify(params) : params
    console.log(params, data, 'params')
  if (config.showLoading) {
    loadingInstance = ElLoading.service({ fullscreen: true })
  }
  return service({
    url,
    method,
    headers,
    [key]: data,
    onUploadProgress: config.progress,
    ...config,
  })
}

const processParams = params => params || {}
fetch.get = (url, config_set = {}) =>
  compose(p => fetch("get", url, {}, p, config_set), processParams)
fetch.post = (url, config_set = {}) =>
  compose(p => fetch("post", url, {}, p, config_set), processParams)
fetch.form = (url, config_set = {}) =>
  compose(
    p => fetch("post", url, { "Content-Type": "application/x-www-form-urlencoded" }, p, config_set),
    processParams
  )
fetch.getForm = (url, config_set = {}) =>
  compose(
    p => fetch("get", url, { "Content-Type": "application/json" }, p, config_set, 'body'),
    processParams
  )

fetch.put = (url, config_set = {}) =>
  compose(
    p => fetch("put", url, { "Content-Type": "multipart/form-data" }, p, config_set),
    processParams
  )

fetch.delete = (url, config_set = {}) =>
  compose(
    p => fetch("delete", url, {}, p, config_set),
    processParams
  )

export default fetch
